import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3, 3, 6, 3),
  },
  fieldGroup: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  data: {
    height: '50px',
    borderRadius: '5px',
    border: `thin solid ${theme.palette.divider}`,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    padding: '8px',
    width: '100%',
    boxSizing: 'border-box',
    '&:focus': {
      borderColor: theme.palette.primary.main,
      outline: 'none',
      borderWidth: '2px',
    },
    '&:hover': {
      borderColor: theme.palette.primary.dark,
    },
  },
  dataInvalida: {
    color: theme.palette.error.main,
    fontSize: '12px',
    marginTop: theme.spacing(0.5),
  },
  botoesFormulario: {
    marginTop: theme.spacing(3),
  },
  linhaTabela: {
    fontSize: '13px',
  },
}))
